// extracted by mini-css-extract-plugin
export default {"extended-togglebox":"Togglebox_extended-togglebox__ycQNA"};